'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "active", "disabled", "href", "role", "isHover", "isFocus", "component", "sentenceCase", "children", "listItemProps", "className", "as"];
import React, { useContext } from 'react';
import { BrowserDefaultFocusStyleContext } from "../../contexts/BrowserDefaultFocusStyleContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { textClass } from "../../styles/index.mjs";
import { ecx } from "../../utils.mjs";
import { TypeListItem } from "../TypeListItem/index.mjs";
/**
 * @deprecated
 * This component will be archived soon.
 * Use the TabsItem component instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-navbar-navbarlistitem--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavBarListItem) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12653&t=X3Pv9ZLvoMIaXVBJ-1)
 */
export var NavBarListItem = /*#__PURE__*/React.forwardRef(function NavBarListItem(_ref, ref) {
  var label = _ref.label,
    active = _ref.active,
    disabled = _ref.disabled,
    href = _ref.href,
    role = _ref.role,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    _ref$component = _ref.component,
    component = _ref$component === void 0 ? 'a' : _ref$component,
    _ref$sentenceCase = _ref.sentenceCase,
    sentenceCase = _ref$sentenceCase === void 0 ? true : _ref$sentenceCase,
    children = _ref.children,
    listItemProps = _ref.listItemProps,
    className = _ref.className,
    as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(BrowserDefaultFocusStyleContext),
    useBrowserDefaultFocusStyle = _useContext.useBrowserDefaultFocusStyle;
  var Link = as || component;
  return /*#__PURE__*/React.createElement(TypeListItem, Object.assign({
    "data-encore-id": ENCORE_DATA_IDS.NavBarListItem,
    condensed: true,
    listStyleReset: true,
    className: ecx(['nav-bar-list-item'], listItemProps === null || listItemProps === void 0 ? void 0 : listItemProps.className)
  }, listItemProps), /*#__PURE__*/React.createElement(Link, Object.assign({
    className: ecx(['nav-bar-list-item__link', {
      'nav-bar-list-item__link--focus-border': !useBrowserDefaultFocusStyle
    }, {
      'nav-bar-list-item__link--active': active
    }, {
      'nav-bar-list-item__link--hover': isHover
    }, {
      'nav-bar-list-item__link--focus': isFocus
    }, {
      'nav-bar-list-item__link--disabled': disabled
    }, textClass(sentenceCase ? 'bodyMediumBold' : 'bodySmallBold')], className),
    ref: ref,
    "aria-current": active ? 'page' : undefined,
    href: !disabled ? href : undefined,
    "aria-disabled": disabled,
    role: disabled && component !== 'button' ? 'link' : role
  }, props), children || label));
});